import { h } from '../dom';
import { api, type Room, type User } from '../../api/client';
import { avatar, empty, guard, section, timeAgo } from '../components';
import { shell } from '../shell';
import { navigate } from '../router';
import { normalizeRoomCode } from '../../net/room';

export function renderRooms(root: HTMLElement, me: User) {
  const content = shell(root, { title: 'Chụp cùng bạn', tab: '#/rooms' });

  // --- create
  const title = h('input.field', { placeholder: 'Tên phòng (vd. Hội bạn thân, Đà Lạt…)', maxLength: 60 });
  let kind: Room['kind'] = 'INSTANT';
  const kinds = h('div.modes', {},
    ...([['INSTANT', '⚡ Phòng nhanh', 'Cho 1 lần chụp, đủ 2 người'], ['PERSISTENT', '🏡 Phòng cố định', 'Giữ lại để chụp với nhóm nhiều lần']] as const)
      .map(([k, t, sub]) => {
        const b = h('button.mode', { class: k === kind ? 'on' : '' }, h('b', {}, t), h('small', {}, sub));
        b.onclick = () => { kind = k; kinds.querySelectorAll('.mode').forEach((x) => x.classList.remove('on')); b.classList.add('on'); };
        return b;
      }));
  const create = h('button.primary', {}, '♡ Tạo phòng & mời bạn');
  create.onclick = async () => {
    create.disabled = true;
    const r = await guard(api.createRoom(title.value.trim() || `Phòng của ${me.displayName}`, kind));
    create.disabled = false;
    if (r) navigate(`#/room/${r.id}?invite=1`);
  };

  // --- join by code
  const code = h('input.field.code', { placeholder: 'MÃ PHÒNG', maxLength: 6, autocapitalize: 'characters' });
  code.oninput = () => (code.value = normalizeRoomCode(code.value));
  const join = h('button.secondary', {}, 'Vào');
  join.onclick = async () => {
    if (code.value.length !== 6) return;
    const r = await guard(api.joinRoom(code.value));
    if (r) navigate(`#/booth/${r.id}`);
  };

  content.append(
    h('section.card', {}, h('h3', {}, 'Phòng mới'), title, kinds, create),
    section(() => api.invites(), (invites, reload) => h('div', {},
      invites.length ? h('h3', {}, `Lời mời vào phòng (${invites.length})`) : '',
      ...invites.map((i) => h('div.urow', {},
        avatar(i.inviter, 44),
        h('div.umain', {}, h('b', {}, i.inviter.displayName), h('small', {}, `mời bạn vào "${i.roomTitle || i.roomCode}" · ${timeAgo(i.createdAt)}`)),
        h('button.primary.small', { onclick: async () => { const r = await guard(api.acceptInvite(i.id)); if (r) navigate(`#/booth/${r.id}`); } }, 'Vào chụp'),
        h('button.secondary.small', { onclick: async () => { await guard(api.declineInvite(i.id)); reload(); } }, 'Bỏ qua'))))),
    h('section.card', {}, h('h3', {}, 'Có mã phòng?'), h('div.row', {}, code, join),
      h('p.tiny', {}, 'Chỉ vào được phòng của bạn bè hoặc phòng bạn được mời.')),
    h('h3', {}, 'Phòng của tôi'),
    section(() => api.rooms(), (rooms) => rooms.length
      ? h('div.ulist', {}, ...rooms.map((r) => h('a.urow', { href: `#/room/${r.id}` },
        h('span.roomicon', {}, r.kind === 'PERSISTENT' ? '🏡' : '⚡'),
        h('div.umain', {}, h('b', {}, r.title || r.code), h('small', {}, `${r.members.length} người · mã ${r.code}`)),
        h('div.avs', {}, ...r.members.slice(0, 4).map((m) => avatar(m.user, 26))))))
      : empty('📸', 'Chưa có phòng nào. Tạo phòng và mời bạn bè nhé!')),
  );
}
